<template>
  <div class="route-waypoint-delete-popup">
    <button @click="handleDeleteClick">Delete Point</button>

    <svg
      width="93"
      height="46"
      viewBox="0 0 93 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="93" height="32" rx="8" fill="currentColor" />
      <path
        d="M47.2568 42.1237C46.858 42.5855 46.142 42.5855 45.7432 42.1237L37 32L56 32L47.2568 42.1237Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script setup>
import routeService from '@/services/route-service'

const handleDeleteClick = () => {
  // Remove the focused route waypoint
  routeService.removeWaypoint(routeService.focusedWaypointIndex)
}
</script>

<!-- eslint-disable vue/enforce-style-attribute -->
<style>
.markup-waypoint-delete.mapboxgl-popup {
  pointer-events: auto;
}
</style>

<style lang="scss" scoped>
@use '@/styles/system/_type';

.route-waypoint-delete-popup {
  position: relative;
  padding-bottom: 8px;

  svg {
    color: var(--ys-color-icon-primary);
  }

  button {
    @include type.button3Type;

    position: absolute;
    top: 0;
    left: 50%;
    width: 100%;
    height: 32px;
    background: none;
    appearance: none;
    color: var(--ys-color-text-reverse);
    transform: translateX(-50%);

    &:hover,
    &:active,
    &:focus {
      background: none;
    }

    &:hover {
      + svg {
        color: var(--ys-color-icon-primary);
      }
    }
  }
}
</style>
